var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component } from 'vue-property-decorator';
import GlobalVue from "../../globalVue";
import StockInitService from '../../api/StockInitService';
import Header from "./components/Header.vue";
import { Loading } from 'element-ui';
import _ from 'lodash';
import Add from './Add';
import { EBillType } from "../../enum/EBillType";
import { toDetail } from '../../helper/util';
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
var PurchaseList = (function (_super) {
    __extends(PurchaseList, _super);
    function PurchaseList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.searchParams = null;
        _this.selectRows = [];
        _this.tableHeight = 300;
        _this.organList = [];
        _this.formData = {};
        _this.isMoreSearch = false;
        _this.shipStatusList = [
            { name: "全部", value: "-1" },
            { name: "待发货", value: 0 },
            { name: "部分发货", value: 1 }
        ];
        return _this;
    }
    PurchaseList.prototype.created = function () {
        this.service = StockInitService.getInstance();
    };
    PurchaseList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
    };
    PurchaseList.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        filter.order_status = filter.order_status.join(',');
        this.filter = filter;
        this.filter.depot_ids = (filter.depot_ids || []).join(',');
        this.getList();
    };
    PurchaseList.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getList(Object.assign({}, this.filter, pager)).then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data;
            _this.total = res.data.total;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    PurchaseList.prototype.audit = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        this.$confirm("审核后将不可修改，是否继续？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                order_ids: _this.selectRows.map(function (item) { return item.order_id; }).join(",")
            };
            _this.service.audit(params).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success("审核成功");
                }
                _this.getList();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseList.prototype.discard = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        this.$confirm("请确认是否废弃选中的单据？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                order_ids: _this.selectRows.map(function (item) { return item.order_id; }).join(",")
            };
            _this.service.discard(params).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success("废弃成功");
                }
                _this.getList();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    PurchaseList.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    PurchaseList.prototype.add = function () {
        this.addTab({
            component: Add,
            title: '添加期初单',
            showExist: true,
            name: 'stockinit_add',
            cprops: {}
        });
    };
    PurchaseList.prototype.edit = function (row) {
        this.addTab({
            component: Add,
            title: '修改期初单',
            showExist: true,
            name: 'stockinit_edit' + row.order_id,
            cprops: {
                orderid: row.order_id
            }
        });
    };
    PurchaseList.prototype.lookDetail = function (row) {
        toDetail(EBillType.StockInit, row.order_id, this);
    };
    PurchaseList.prototype.resetData = function () {
    };
    PurchaseList.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    PurchaseList = __decorate([
        auth(nameDict["库存初始化"], true),
        Component({
            components: {
                'list-header': Header
            },
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData'
            }))
        })
    ], PurchaseList);
    return PurchaseList;
}(Vue));
export default PurchaseList;
